import { render, staticRenderFns } from "./TeachingPeriod.vue?vue&type=template&id=d59e0718&"
import script from "./TeachingPeriod.vue?vue&type=script&lang=js&"
export * from "./TeachingPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports